import React from "react";
import { Tooltip, IconButton } from "@toddle-edu/ds-web";
import { InformationOutlined } from "@toddle-edu/ds-icons";

const ColumnInfoTooltip = props => {
  const { tooltip } = props;
  return (
    <div style={{ marginTop: "4px", marginLeft: "2px" }}>
      <Tooltip
        tooltip={tooltip}
        placement="bottomRight"
        align={{ offset: [25, 8] }}
        overlayInnerStyle={{ width: "200px" }}
      >
        <IconButton
          icon={<InformationOutlined variant="on" />}
          variant={"dark"}
          size={"xx-small"}
        />
      </Tooltip>
    </div>
  );
};

export default ColumnInfoTooltip;
